// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce #easycommerce_dashboard_render {
    width: 100%;
}
.easycommerce .easycommerce-sidebar-image-btn:hover {
    background: transparent;
    border-color: #dbdbdb;
}
.easycommerce .easycommerce-sidebar-image-btn:focus {
    background: transparent;
    border-color: #dbdbdb;
}
.easycommerce .easycommerce-dashboard-section h3,
.easycommerce .easycommerce-dashboard-section h4,
.easycommerce .easycommerce-dashboard-section p {
    margin: 0;
}
.easycommerce .easycommerce-dashboard-section-title {
    color: #120350;
    font-family: "Inter", sans-serif;
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
}
.easycommerce .easycommerce-dashboard-section .view-more-btn {
    color: var(--color-ec-placeholder);
    text-decoration: none;
}
.easycommerce .easycommerce-dashboard-section .view-more-btn:hover {
    color: var(--color-ec-secondary);
}
.easycommerce .easycommerce-dashboard-section .view-more-btn:focus {
    outline: none;
    color: var(--color-ec-placeholder);
}
.easycommerce #easycommerce_dashboard_render table tr.last-row td {
    border: none;
}
.easycommerce .easycommerce-dashboard-summery-list h4 {
    color: var(--color-ec-body);
    font-size: 16px;
    line-height: 26px;
    font-weight: 600;
}
.easycommerce .easycommerce-dashboard-summery-list p {
    color: var(--color-ec-placeholder);
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
}
.easycommerce
    #easycommerce_dashboard_render
    .dashboard-sidebar
    .dashboard-sidebar-title {
    color: var(--color-ec-body);
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;
    margin: 0;
}
.easycommerce
    #easycommerce_dashboard_render
    .dashboard-sidebar
    .easycommerce-sidebar-btn,
.easycommerce
    #easycommerce_dashboard_render
    .dashboard-sidebar
    .easycommerce-submenu-btn {
    border: none;
    box-shadow: none;
    text-decoration: unset;
}
.easycommerce
    #easycommerce_dashboard_render
    .dashboard-sidebar
    .easycommerce-sidebar-btn:hover,
.easycommerce
    #easycommerce_dashboard_render
    .dashboard-sidebar
    .easycommerce-sidebar-btn:focus,
.easycommerce
    #easycommerce_dashboard_render
    .dashboard-sidebar
    .easycommerce-submenu-btn:hover,
.easycommerce
    #easycommerce_dashboard_render
    .dashboard-sidebar
    .easycommerce-submenu-btn:focus {
    background: none;
    outline: none;
    box-shadow: none;
}
.easycommerce
    #easycommerce_dashboard_render
    .dashboard-sidebar
    .easycommerce-submenu-btn.active {
    background: #f9f9f9;
    border-radius: 4px;
}
.easycommerce
    #easycommerce_dashboard_render
    .dashboard-sidebar
    .easycommerce-submenu-btn.active
    span {
    color: var(--color-ec-body);
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-search-btn {
    background: var(--color-ec-primary);
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-search-btn:focus {
    background: var(--color-ec-secondary);
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-search-input {
    width: 312px;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: var(--color-ec-body);
    background-color: #f8f8f8;
    border: 1px solid var(--color-ec-border);
    border-radius: 6px;
    padding: 11px 16px;
    height: 48px;
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-search-input::-moz-placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-search-input::placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-search-input:focus {
    border: 1px solid var(--color-ec-primary);
    outline: none;
    box-shadow: none;
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-download-btn {
    max-width: 105px;
    background: #fff;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    text-decoration: none;
    color: var(--color-ec-primary);
    padding: 9px 7.5px;
    margin: 0 auto;
    border: 1px solid var(--color-ec-primary);
    box-shadow: 0px 4px 20px 0px #eeeeee80;
    border-radius: 4px;
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-download-btn:hover {
    background: var(--color-ec-primary);
    color: #fff;
}
.easycommerce #easycommerce_dashboard_render .easycommerce-dashboard-input {
    height: 48px;
    font-family: "Inter", sans-serif;
    font-size: 14px;
    line-height: 26px;
    font-weight: 400;
    padding: 11px 12px;
    border: 1px solid var(--color-ec-border);
    border-radius: 8px;
    box-shadow: none;
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-input::-moz-placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-input::placeholder {
    color: var(--color-ec-placeholder);
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-input:hover {
    border-color: var(--color-ec-secondary);
}

.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-input:focus {
    color: var(--color-ec-body);
    border-color: var(--color-ec-primary);
    outline: none;
    box-shadow: 0px 2px 4.5px 0px var(--color-ec-shadow);
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-input-select {
    height: 48px;
    padding: 11px 12px;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    line-height: 26px;
    font-weight: 400;
    border: 1px solid var(--color-ec-border);
    border-radius: 6px;
    box-shadow: none;
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-input-select:hover {
    border-color: var(--color-ec-secondary);
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-input-select:focus {
    color: var(--color-ec-body);
    border-color: var(--color-ec-primary);
    outline: none;
    box-shadow: 0px 2px 4.5px 0px var(--color-ec-shadow);
}
.easycommerce #easycommerce_dashboard_render .easycommerce-dashboard-form-btn {
    width: 180px;
    height: 48px;
    text-align: center;
    border: 1px solid var(--color-ec-primary);
    border-radius: 6px;
    background: #fff;
    color: var(--color-ec-primary);
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
    transition: 0.4s all ease-in-out;
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-form-btn:hover {
    background: var(--color-ec-primary);
    color: #fff;
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-form-btn.save {
    background: var(--color-ec-primary);
    color: #fff;
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-address-title {
    font-family: "Inter", sans-serif;
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
    color: var(--color-ec-body);
    margin: 0;
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-password-heading {
    font-family: "Inter", sans-serif;
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
    color: #000;
    margin: 0;
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-password-subheading {
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: var(--color-ec-placeholder);
    margin: 0;
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-form-password-input {
    border: none;
    box-shadow: none;
    outline: none;
    height: unset;
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-form-password-input:focus {
    border: none;
    box-shadow: none;
    outline: none;
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-form-password-input[type="password"] {
    color: #dbdbdb;
    border-radius: 8px;
    border-right: none;
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-form-password:focus-within {
    border: 1px solid var(--color-ec-primary) !important;
    box-shadow: 0px 2px 4.5px 0px var(--color-ec-shadow);
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-form-password-input[type="text"] {
    color: var(--color-ec-body);
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-form-password-show-hide-btn:hover,
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-form-password-show-hide-btn:focus {
    background: none;
    box-shadow: none;
}
.easycommerce
    #easycommerce_dashboard_render
    .easycommerce-dashboard-order-section-title {
    font-size: 16px;
    line-height: 26px;
    font-weight: 600;
    color: var(--color-ec-body);
}
`, "",{"version":3,"sources":["webpack://./spa/public/dashboard/assets/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;AACA;IACI,uBAAuB;IACvB,qBAAqB;AACzB;AACA;;;IAGI,SAAS;AACb;AACA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,kCAAkC;IAClC,qBAAqB;AACzB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,aAAa;IACb,kCAAkC;AACtC;AACA;IACI,YAAY;AAChB;AACA;IACI,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;;;;IAII,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;AACb;AACA;;;;;;;;IAQI,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;AAC1B;AACA;;;;;;;;;;;;;;;;IAgBI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;AACA;;;;IAII,mBAAmB;IACnB,kBAAkB;AACtB;AACA;;;;;IAKI,2BAA2B;AAC/B;AACA;;;IAGI,mCAAmC;AACvC;AACA;;;IAGI,qCAAqC;AACzC;AACA;;;IAGI,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B,yBAAyB;IACzB,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;AACA;;;IAGI,kCAAkC;AACtC;AAJA;;;IAGI,kCAAkC;AACtC;AACA;;;IAGI,yCAAyC;IACzC,aAAa;IACb,gBAAgB;AACpB;AACA;;;IAGI,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,yCAAyC;IACzC,sCAAsC;IACtC,kBAAkB;AACtB;AACA;;;IAGI,mCAAmC;IACnC,WAAW;AACf;AACA;IACI,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;;;IAGI,kCAAkC;AACtC;AAJA;;;IAGI,kCAAkC;AACtC;AACA;;;IAGI,uCAAuC;AAC3C;;AAEA;;;IAGI,2BAA2B;IAC3B,qCAAqC;IACrC,aAAa;IACb,oDAAoD;AACxD;AACA;;;IAGI,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;AACpB;AACA;;;IAGI,uCAAuC;AAC3C;AACA;;;IAGI,2BAA2B;IAC3B,qCAAqC;IACrC,aAAa;IACb,oDAAoD;AACxD;AACA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;IAChB,8BAA8B;IAC9B,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;AACpC;AACA;;;IAGI,mCAAmC;IACnC,WAAW;AACf;AACA;;;IAGI,mCAAmC;IACnC,WAAW;AACf;AACA;;;IAGI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B,SAAS;AACb;AACA;;;IAGI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,SAAS;AACb;AACA;;;IAGI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;IAClC,SAAS;AACb;AACA;;;IAGI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,aAAa;AACjB;AACA;;;IAGI,YAAY;IACZ,gBAAgB;IAChB,aAAa;AACjB;AACA;;;IAGI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;AACA;;;IAGI,oDAAoD;IACpD,oDAAoD;AACxD;AACA;;;IAGI,2BAA2B;IAC3B,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;;;;;;IAMI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;;;IAGI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;AAC/B","sourcesContent":[".easycommerce #easycommerce_dashboard_render {\n    width: 100%;\n}\n.easycommerce .easycommerce-sidebar-image-btn:hover {\n    background: transparent;\n    border-color: #dbdbdb;\n}\n.easycommerce .easycommerce-sidebar-image-btn:focus {\n    background: transparent;\n    border-color: #dbdbdb;\n}\n.easycommerce .easycommerce-dashboard-section h3,\n.easycommerce .easycommerce-dashboard-section h4,\n.easycommerce .easycommerce-dashboard-section p {\n    margin: 0;\n}\n.easycommerce .easycommerce-dashboard-section-title {\n    color: #120350;\n    font-family: \"Inter\", sans-serif;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 32px;\n}\n.easycommerce .easycommerce-dashboard-section .view-more-btn {\n    color: var(--color-ec-placeholder);\n    text-decoration: none;\n}\n.easycommerce .easycommerce-dashboard-section .view-more-btn:hover {\n    color: var(--color-ec-secondary);\n}\n.easycommerce .easycommerce-dashboard-section .view-more-btn:focus {\n    outline: none;\n    color: var(--color-ec-placeholder);\n}\n.easycommerce #easycommerce_dashboard_render table tr.last-row td {\n    border: none;\n}\n.easycommerce .easycommerce-dashboard-summery-list h4 {\n    color: var(--color-ec-body);\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 600;\n}\n.easycommerce .easycommerce-dashboard-summery-list p {\n    color: var(--color-ec-placeholder);\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 20px;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .dashboard-sidebar\n    .dashboard-sidebar-title {\n    color: var(--color-ec-body);\n    font-size: 20px;\n    font-weight: 600;\n    line-height: 32px;\n    margin: 0;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .dashboard-sidebar\n    .easycommerce-sidebar-btn,\n.easycommerce\n    #easycommerce_dashboard_render\n    .dashboard-sidebar\n    .easycommerce-submenu-btn {\n    border: none;\n    box-shadow: none;\n    text-decoration: unset;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .dashboard-sidebar\n    .easycommerce-sidebar-btn:hover,\n.easycommerce\n    #easycommerce_dashboard_render\n    .dashboard-sidebar\n    .easycommerce-sidebar-btn:focus,\n.easycommerce\n    #easycommerce_dashboard_render\n    .dashboard-sidebar\n    .easycommerce-submenu-btn:hover,\n.easycommerce\n    #easycommerce_dashboard_render\n    .dashboard-sidebar\n    .easycommerce-submenu-btn:focus {\n    background: none;\n    outline: none;\n    box-shadow: none;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .dashboard-sidebar\n    .easycommerce-submenu-btn.active {\n    background: #f9f9f9;\n    border-radius: 4px;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .dashboard-sidebar\n    .easycommerce-submenu-btn.active\n    span {\n    color: var(--color-ec-body);\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-search-btn {\n    background: var(--color-ec-primary);\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-search-btn:focus {\n    background: var(--color-ec-secondary);\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-search-input {\n    width: 312px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n    color: var(--color-ec-body);\n    background-color: #f8f8f8;\n    border: 1px solid var(--color-ec-border);\n    border-radius: 6px;\n    padding: 11px 16px;\n    height: 48px;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-search-input::placeholder {\n    color: var(--color-ec-placeholder);\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-search-input:focus {\n    border: 1px solid var(--color-ec-primary);\n    outline: none;\n    box-shadow: none;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-download-btn {\n    max-width: 105px;\n    background: #fff;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 16px;\n    text-decoration: none;\n    color: var(--color-ec-primary);\n    padding: 9px 7.5px;\n    margin: 0 auto;\n    border: 1px solid var(--color-ec-primary);\n    box-shadow: 0px 4px 20px 0px #eeeeee80;\n    border-radius: 4px;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-download-btn:hover {\n    background: var(--color-ec-primary);\n    color: #fff;\n}\n.easycommerce #easycommerce_dashboard_render .easycommerce-dashboard-input {\n    height: 48px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 14px;\n    line-height: 26px;\n    font-weight: 400;\n    padding: 11px 12px;\n    border: 1px solid var(--color-ec-border);\n    border-radius: 8px;\n    box-shadow: none;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-input::placeholder {\n    color: var(--color-ec-placeholder);\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-input:hover {\n    border-color: var(--color-ec-secondary);\n}\n\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-input:focus {\n    color: var(--color-ec-body);\n    border-color: var(--color-ec-primary);\n    outline: none;\n    box-shadow: 0px 2px 4.5px 0px var(--color-ec-shadow);\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-input-select {\n    height: 48px;\n    padding: 11px 12px;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 400;\n    border: 1px solid var(--color-ec-border);\n    border-radius: 6px;\n    box-shadow: none;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-input-select:hover {\n    border-color: var(--color-ec-secondary);\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-input-select:focus {\n    color: var(--color-ec-body);\n    border-color: var(--color-ec-primary);\n    outline: none;\n    box-shadow: 0px 2px 4.5px 0px var(--color-ec-shadow);\n}\n.easycommerce #easycommerce_dashboard_render .easycommerce-dashboard-form-btn {\n    width: 180px;\n    height: 48px;\n    text-align: center;\n    border: 1px solid var(--color-ec-primary);\n    border-radius: 6px;\n    background: #fff;\n    color: var(--color-ec-primary);\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 26px;\n    transition: 0.4s all ease-in-out;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-form-btn:hover {\n    background: var(--color-ec-primary);\n    color: #fff;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-form-btn.save {\n    background: var(--color-ec-primary);\n    color: #fff;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-address-title {\n    font-family: \"Inter\", sans-serif;\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 32px;\n    color: var(--color-ec-body);\n    margin: 0;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-password-heading {\n    font-family: \"Inter\", sans-serif;\n    font-size: 24px;\n    font-weight: 600;\n    line-height: 32px;\n    color: #000;\n    margin: 0;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-password-subheading {\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n    color: var(--color-ec-placeholder);\n    margin: 0;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-form-password-input {\n    border: none;\n    box-shadow: none;\n    outline: none;\n    height: unset;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-form-password-input:focus {\n    border: none;\n    box-shadow: none;\n    outline: none;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-form-password-input[type=\"password\"] {\n    color: #dbdbdb;\n    border-radius: 8px;\n    border-right: none;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-form-password:focus-within {\n    border: 1px solid var(--color-ec-primary) !important;\n    box-shadow: 0px 2px 4.5px 0px var(--color-ec-shadow);\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-form-password-input[type=\"text\"] {\n    color: var(--color-ec-body);\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-form-password-show-hide-btn:hover,\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-form-password-show-hide-btn:focus {\n    background: none;\n    box-shadow: none;\n}\n.easycommerce\n    #easycommerce_dashboard_render\n    .easycommerce-dashboard-order-section-title {\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 600;\n    color: var(--color-ec-body);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
